var _path, _rect, _rect2, _rect3, _rect4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon13(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.131 1.90902H12.795V0.856023C12.795 0.336024 12.442 -0.000976562 11.938 -0.000976562C11.433 -0.000976562 11.08 0.336024 11.08 0.856023V1.90902H5.498V0.856023C5.5 0.499023 5.5 0 4.5 -0.000976562C4 -0.000976562 3.783 0.336024 3.783 0.856023V1.90902H3.009C1.379 1.90902 0 3.08702 0 4.95902V13.794C0 15.422 1.379 16.798 3.009 16.798H13.131C14.762 16.798 16.141 15.422 16.141 13.794V4.95902C16.141 3.08702 14.762 1.90902 13.131 1.90902ZM3.009 3.42302H13.131C13.821 3.42302 14.426 4.02702 14.426 4.95902V5.90802H1.715V4.95902C1.715 4.02702 2.32 3.42302 3.009 3.42302ZM13.131 15.07H3.009C2.32 15.07 1.715 14.499 1.715 13.794V7.61802H14.409V13.794C14.409 14.499 13.821 15.07 13.131 15.07Z",
    fill: "url(#paint0_linear_7_1652)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 9,
    width: 3,
    height: 1.5,
    fill: "url(#paint1_linear_7_1652)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 12,
    width: 3,
    height: 1.5,
    fill: "url(#paint2_linear_7_1652)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 9,
    width: 3,
    height: 1.5,
    fill: "url(#paint3_linear_7_1652)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 12,
    width: 3,
    height: 1.5,
    fill: "url(#paint4_linear_7_1652)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7_1652",
    x1: 16.141,
    y1: 16.798,
    x2: -1.75429,
    y2: 14.6562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0112,
    stopColor: "#FD225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7A40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7_1652",
    x1: 7,
    y1: 10.5,
    x2: 3.82346,
    y2: 9.70861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0112,
    stopColor: "#FD225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7A40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7_1652",
    x1: 7,
    y1: 13.5,
    x2: 3.82346,
    y2: 12.7086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0112,
    stopColor: "#FD225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7A40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7_1652",
    x1: 12,
    y1: 10.5,
    x2: 8.82346,
    y2: 9.70861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0112,
    stopColor: "#FD225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7A40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_7_1652",
    x1: 12,
    y1: 13.5,
    x2: 8.82346,
    y2: 12.7086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0112,
    stopColor: "#FD225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7A40"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon13);
export default __webpack_public_path__ + "static/media/icon-13.d8f633ee4d91f5ed49a5f7600fab2e7a.svg";
export { ForwardRef as ReactComponent };